export default __webpack_public_path__ + "static/media/tbFormat3.54e711d2.png";